import { useEffect } from "react";
import { useDispatch, useSelector } from "react-redux";

import { resolveHostTenantAsync } from "./hostTenantSlice";

import type { AppDispatch, RootState } from "@/redux/store";

/**
 * Resolves the tenant for the current hostname once per app boot, ahead of
 * (and independent of) authentication — used to brand the login screen.
 */
export function HostTenantBootstrap() {
  const dispatch = useDispatch<AppDispatch>();
  const status = useSelector((state: RootState) => state.hostTenant.status);

  useEffect(() => {
    if (status !== "idle") {
      return;
    }

    dispatch(resolveHostTenantAsync({ host: window.location.hostname }));
  }, [dispatch, status]);

  return null;
}
